import Component from '@glimmer/component';
import OnboardModel from 'donor-elf-web/models/onboard';

interface ComponentArgs {
  onboard: OnboardModel;
}

export default class DashboardOnboardIndexComponents extends Component<ComponentArgs> {}
